import { render, staticRenderFns } from "./ByWeek.vue?vue&type=template&id=f4fab4ca&scoped=true&"
import script from "./ByWeek.vue?vue&type=script&lang=js&"
export * from "./ByWeek.vue?vue&type=script&lang=js&"
import style0 from "./ByWeek.vue?vue&type=style&index=0&id=f4fab4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fab4ca",
  null
  
)

export default component.exports